<div class="container-text">
    <div class="container-content-text">
      <ng-content class="container-content-text"></ng-content>
    </div>
</div>
